<template>
    <div class="shop-page">
        <!-- Header Navigation -->
        <main-header/>

        <!-- Promotional Banner -->
        <div class="promo-banner" v-if="!isLoggedIn">
            Sign up and <span class="highlight">GET 10% OFF</span> for your first order. 
            <router-link to="/signup" class="sign-up-link">Sign up now</router-link>
        </div>

        <!-- Hero Section -->
        <section class="hero-section">
            <!-- <img src="@/assets/images/hero-banner.jpg" alt="My Oxytocin" class="hero-image" /> -->
            <div class="hero-overlay">
            </div>
        </section>

        <!-- Category Navigation Bar -->
        <div class="category-nav">
            <div class="category-list-container">
                <div class="category-list-track">
                    <!-- Extended content for seamless infinite scrolling -->
                    <span class="category-item">· ACCOMPANIA ·</span>
                    <span class="category-item">· EVERLAST ·</span>
                    <span class="category-item">· ARTISTCO ·</span>
                    <span class="category-item">· ACCOMPANIA ·</span>
                    <span class="category-item">· EVERLAST ·</span>
                    <span class="category-item">· ARTISTCO ·</span>
                    <span class="category-item">· ACCOMPANIA ·</span>
                    <span class="category-item">· EVERLAST ·</span>
                    <span class="category-item">· ARTISTCO ·</span>
                    <span class="category-item">· ACCOMPANIA ·</span>
                    <span class="category-item">· EVERLAST ·</span>
                    <span class="category-item">· ARTISTCO ·</span>
                    <span class="category-item">· ACCOMPANIA ·</span>
                    <span class="category-item">· EVERLAST ·</span>
                    <span class="category-item">· ARTISTCO ·</span>
                    <span class="category-item">· ACCOMPANIA ·</span>
                    <span class="category-item">· EVERLAST ·</span>
                    <span class="category-item">· ARTISTCO ·</span>
                    <span class="category-item">· ACCOMPANIA ·</span>
                    <span class="category-item">· EVERLAST ·</span>
                    <span class="category-item">· ARTISTCO ·</span>
                    <span class="category-item">· ACCOMPANIA ·</span>
                    <span class="category-item">· EVERLAST ·</span>
                    <span class="category-item">· ARTISTCO ·</span>
                    <!-- Duplicate for seamless loop -->
                    <span class="category-item">· ACCOMPANIA ·</span>
                    <span class="category-item">· EVERLAST ·</span>
                    <span class="category-item">· ARTISTCO ·</span>
                    <span class="category-item">· ACCOMPANIA ·</span>
                    <span class="category-item">· EVERLAST ·</span>
                    <span class="category-item">· ARTISTCO ·</span>
                    <span class="category-item">· ACCOMPANIA ·</span>
                    <span class="category-item">· EVERLAST ·</span>
                    <span class="category-item">· ARTISTCO ·</span>
                    <span class="category-item">· ACCOMPANIA ·</span>
                    <span class="category-item">· EVERLAST ·</span>
                    <span class="category-item">· ARTISTCO ·</span>
                    <span class="category-item">· ACCOMPANIA ·</span>
                    <span class="category-item">· EVERLAST ·</span>
                    <span class="category-item">· ARTISTCO ·</span>
                    <span class="category-item">· ACCOMPANIA ·</span>
                    <span class="category-item">· EVERLAST ·</span>
                    <span class="category-item">· ARTISTCO ·</span>
                    <span class="category-item">· ACCOMPANIA ·</span>
                    <span class="category-item">· EVERLAST ·</span>
                    <span class="category-item">· ARTISTCO ·</span>
                    <span class="category-item">· ACCOMPANIA ·</span>
                    <span class="category-item">· EVERLAST ·</span>
                    <span class="category-item">· ARTISTCO ·</span>
                </div>
            </div>
        </div>

        <!-- Main Shop Container -->
        <div class="container shop-container">
            <!-- Main Content Area -->
            <div class="main-content">
                <!-- Best Sellers and Featured Section -->
                <section class="featured-section">
                    <div class="bestsellers-container">
                        <!-- Left: Customization Box -->
                        <div class="customization-card">
                            <div class="bestsellers-title">
                                <img src="/assets/images/Product Listing Page/Group 17.png"/>
                            </div>
                            <div class="customization-cat">
                                <img src="/assets/images/Product Listing Page/Rectangle 21.png" alt="">
                            </div>
                            <div class="custom-content">
                                <!-- <img src="@/assets/images/cat-custom.jpg" alt="Cat" class="custom-image" /> -->
                                <div class="custom-text">
                                    <h3>WANT TO CUSTOMIZE YOUR OWN BOXES?</h3>
                                    <button class="journey-btn" @click="highlightFeaturedBoxes">
                                        CHOOSE YOUR<br/>GIFT BOX<br/>TO START
                                        <svg class="arrow-icon" width="20" height="12" viewBox="0 0 20 12">
                                            <path d="M14 1L19 6M19 6L14 11M19 6H1" stroke="currentColor" stroke-width="2"/>
                        </svg>
                    </button>
                </div>
            </div>
        </div>

                        <!-- Right: Featured Gift Boxes -->
                        <div class="featured-boxes" ref="featuredBoxes">
                            <div class="gift-box-card" v-for="product in featuredProducts" :key="product._id" @click="$router.push('/set/' + product._id)">
                                <div class="product-label">{{ getItemCountLabel(product) }}</div>
                                <div class="box-image">
                                    <img :src="(product.images && (product.images[1]))" :alt="product.name" />
                                </div>
                                <div class="box-info">
                                    <h4>{{ product.name }}</h4>
                                    <div class="rating-price">
                                        <div class="rating">
                                            <span class="stars">★</span>
                                            <span>{{ product.rating || 4.9 }}</span>
                                        </div>
                                        <div class="price-info">
                                            <span v-if="product.original_price" class="old-price">${{ product.original_price }}</span>
                                            <span class="price">${{ product.price }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            <!-- Filters Bar -->
            <div class="filters-bar">
                    <div class="filter-dropdown">
                        <span class="filter-label">All</span>
                    </div>
                    
                    <div class="sort-section">
                        <span class="sort-label">Sort by Price</span>
                    </div>
                    
                <!-- Price Range Slider -->
                <div class="price-range-section">
                    <span class="price-label-left">$0</span>
                    <div class="price-slider-wrapper">
                        <div class="price-slider-container">
                            <input 
                                type="range" 
                                :min="0" 
                                :max="100" 
                                v-model.number="priceMin"
                                class="price-slider min-slider"
                            />
                            <input 
                                type="range" 
                                :min="0" 
                                :max="100" 
                                v-model.number="priceMax"
                                class="price-slider max-slider"
                            />
                            <div class="price-track">
                                <div class="price-track-active" :style="priceTrackStyle"></div>
                            </div>
                        </div>
                        <div class="price-values">
                            <span class="current-min">${{ priceMin }}</span>
                            <span class="current-max">${{ priceMax }}</span>
                        </div>
                    </div>
                    <span class="price-label-right">$100</span>
                </div>
                    
                    <!-- Stock Filters -->
                    <div class="stock-filters">
                        <label class="checkbox-filter">
                            <input 
                                type="checkbox" 
                                v-model="filterOptions.onSale"
                                @change="filterProducts"
                            />
                            <span class="checkbox-custom"></span>
                            <span>On Sale</span>
                        </label>
                        
                        <label class="checkbox-filter">
                            <input 
                                type="checkbox" 
                                v-model="filterOptions.inStock"
                                @change="filterProducts"
                            />
                            <span class="checkbox-custom"></span>
                            <span>In Stock</span>
                        </label>
                </div>
            </div>
            
            <!-- Products Grid -->
                <div class="products-grid" v-if="loaded">
                <div 
                        class="product-card" 
                        v-for="(product, index) in displayProducts" 
                    :key="index"
                        @click="$router.push('/item/' + product._id)"
                    >
                        <!-- Badges -->
                        <div class="product-badges">
                            <span v-if="product.hot_new" class="badge hot-new">HOT NEW</span>
                            <span v-if="product.discount" class="badge on-sale">ON SALE</span>
                            <span v-if="product.top_pick" class="badge top-pick">TOP PICK</span>
                        </div>

                        <!-- Discount Badge -->
                        <div class="discount-badge" v-if="product.discount">
                            <!-- <span>-{{ product.discount }}%</span> -->
                        </div>
                    
                        <!-- Product Image -->
                        <div class="product-image">
                            <img :src="product.images[0]" :alt="product.name" />
                </div>

                        <!-- Product Info -->
                        <div class="product-info">
                            <h3 class="product-name">{{ product.name }}</h3>
                            <div class="product-footer">
                                <div class="rating">
                                    <span class="star">★</span>
                                    <span class="rating-value">{{ product.rating || 4.9 }}</span>
            </div>
                                <div class="price-section">
                                    <span v-if="product.oldPrice" class="old-price">${{ product.oldPrice }}</span>
                                    <span class="current-price">${{ product.price }}</span>
        </div>
    </div>
                        </div>
                    </div>
                </div>
                <div v-else class="loading-container">
                    <div class="loader"></div>
                    <p>Loading products...</p>
                </div>

                <!-- View More -->
                <div class="view-more-section">
                    <p>You have viewed {{ displayProducts.length }} out of {{ products.length }}.</p>
                </div>
            </div>
        </div>

        <!-- Personalization CTA Section -->
        <section class="cta-section">
            <h2>Start your personalization journey?</h2>
            <button class="cta-btn" @click.prevent="highlightFeaturedBoxes">Choose your gift box here</button>
        </section>

        <!-- Footer -->
        <main-footer/>
    </div>
</template>

<script>
import MainHeader from "@/components/MainHeader.vue";
import MainFooter from "@/components/MainFooter.vue";
import { auth } from "@/firebase/init";
import { onAuthStateChanged } from "firebase/auth";

export default {
    name: "ShopView",
    components: {
        MainHeader,
        MainFooter
    },
    data() {
        return {
            products: [],
            displayProducts: [],
            featuredProducts: [],
            loaded: false,
            priceMin: 0,
            priceMax: 100,
            filterOptions: {
                onSale: false,  // Changed to false to show all products by default
                inStock: false, // Changed to false to show all products by default
                outOfStock: false,
            },
            isLoggedIn: false,
        };
    },
    computed: {
        priceTrackStyle() {
            const minPercent = (this.priceMin / 100) * 100;
            const maxPercent = (this.priceMax / 100) * 100;
            return {
                left: `${minPercent}%`,
                width: `${maxPercent - minPercent}%`
            };
        }
    },
    watch: {
        priceMin(newVal) {
            const val = Number(newVal);
            if (val > this.priceMax) {
                this.priceMax = val;
            }
            this.filterProducts();
        },
        priceMax(newVal) {
            const val = Number(newVal);
            if (val < this.priceMin) {
                this.priceMin = val;
            }
            this.filterProducts();
        }
    },
    created() {
        this.getProducts();
        onAuthStateChanged(auth, (user) => {
            if (user) {
                this.isLoggedIn = true;
            } else {
                this.isLoggedIn = false;
            }
        });
    },
    methods: {
        highlightFeaturedBoxes() {
            // emphasize only the box images (pulse + scroll into view) without navigation
            const container = this.$refs.featuredBoxes;
            if (!container) return;
            container.scrollIntoView({ behavior: 'smooth', block: 'center' });
            const boxes = container.querySelectorAll('.box-image');
            boxes.forEach((el) => {
                el.classList.add('highlight-pulse');
                setTimeout(() => el.classList.remove('highlight-pulse'), 1200);
            });
        },
        getProducts() {
            this.loaded = false;
            
            // Load products from individual_products.json
            fetch("/data/individual_products.json")
                .then((response) => response.json())
                .then((data) => {
                    // Map the data to match the expected format (id -> _id)
                    // Filter out products without images
                    this.products = data
                        .filter(product => product.images && product.images.length > 0)
                        .map(product => {
                            let discount = product.discount;
                            let on_sale = product.on_sale;

                            // Calculate discount if oldPrice exists and is greater than price
                            if (product.oldPrice && product.price < product.oldPrice) {
                                discount = Math.round(((product.oldPrice - product.price) / product.oldPrice) * 100);
                                on_sale = true;
                            }

                            return {
                                _id: product.id,
                                name: product.name,
                                price: product.price,
                                oldPrice: product.oldPrice,
                                rating: product.rating,
                                images: product.images,
                                on_sale: on_sale,
                                discount: discount,
                                top_pick: product.top_pick,
                                in_stock: product.in_stock
                            };
                        });
                    this.filterProducts();
                    this.loaded = true;
                })
                .catch((error) => {
                    console.error('Error loading products:', error);
                    this.products = [];
                    this.loaded = true;
                });
            
            // Load featured products from products.json
            fetch("/data/products.json")
                .then((response) => response.json())
                .then((data) => {
                    const sets = ["Accompania", "Everlast", "Artistico"]; // featured names
                    const results = data?.results || [];
                    this.featuredProducts = results.filter(p => sets.includes(p.name));
                })
                .catch(() => {
                    this.featuredProducts = [];
                });
        },
        filterProducts() {
            let filtered = [...this.products];
            
            // Filter by price range
            filtered = filtered.filter(product => {
                const price = product.price;
                return price >= this.priceMin && price <= this.priceMax;
            });
            
            // Save the price-filtered list before applying stock filters
            const priceFiltered = [...filtered];
            
            // Filter by stock status - only apply if at least one filter is checked
            const hasActiveFilters = this.filterOptions.onSale || this.filterOptions.inStock || this.filterOptions.outOfStock;
            
            if (hasActiveFilters) {
                filtered = filtered.filter(product => {
                    let shouldShow = false;
                    if (this.filterOptions.onSale && product.on_sale) shouldShow = true;
                    if (this.filterOptions.inStock && product.in_stock) shouldShow = true;
                    if (this.filterOptions.outOfStock && !product.in_stock) shouldShow = true;
                    return shouldShow;
                });
                
                // If stock filters result in no products, fall back to price-filtered list
                if (filtered.length === 0) {
                    filtered = priceFiltered;
                }
            }
            
            this.displayProducts = filtered;
        },
        startJourney() {
            this.$router.push('/personalization');
        },
        getItemCountLabel(product) {
            // Default item counts for known sets (all gift boxes have 6 items)
            console.log(product);
            const itemCount = product.item_count || 6;
            return `${itemCount} items inside`;
        },
    },
};
</script>

<style scoped>
/* Main Shop Page Container */
.shop-page {
    background: #fffef9;
    min-height: 100vh;
    font-family: 'Jost', sans-serif;
    overflow-x: hidden; /* Prevent horizontal scroll */
}
.customization-cat{
    position: absolute;
    top: 3%;
    left: 4%;
    z-index: -1;
}
.customization-cat img{
    width: 340px;
    height: auto;
    max-width: 100%;
}
/* Header Styles */
.main-header {
    background: white;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 30px;
    height: 60px;
    border-bottom: 1px solid #f0f0f0;
}

.logo-section .logo {
    height: 40px;
    object-fit: contain;
}

.main-nav {
    display: flex;
    gap: 30px;
    align-items: center;
}

.nav-item {
    display: flex;
    align-items: center;
    gap: 8px;
    font-family: 'Eczar', serif;
    font-size: 14px;
    font-weight: 500;
    color: #000;
    cursor: pointer;
    position: relative;
}

.nav-item:hover {
    color: #e37267;
}

.dropdown-icon {
    margin-top: 2px;
}

.header-actions {
    display: flex;
    gap: 15px;
}

.cart-btn, .login-btn {
    padding: 10px 25px;
    border-radius: 5px;
    font-size: 14px;
    font-weight: bold;
    cursor: pointer;
    border: none;
    transition: all 0.3s ease;
}

.cart-btn {
    background: #e37267;
    color: white;
}

.cart-btn:hover {
    background: #d45d52;
    box-shadow: 0 2px 8px rgba(227, 114, 103, 0.3);
}

.login-btn {
    background: #f1cab3;
    color: #000;
}

.login-btn:hover {
    background: #e4b9a0;
}

/* Promotional Banner */
.promo-banner {
    background: #ffe1cf;
    text-align: center;
    padding: 8px;
    font-size: 14px;
    color: #000;
}

.promo-banner .highlight {
    color: #a00003;
    font-weight: 600;
}

.promo-banner .sign-up-link {
    color: #000;
    text-decoration: underline;
    cursor: pointer;
}

.promo-banner .sign-up-link:hover {
    color: #e37267;
}

/* Hero Section */
.hero-section {
    position: relative;
    height: 360px;
    overflow: hidden;
    background: linear-gradient(135deg, #ffe1cf 0%, #ffeee5 100%);
}

.hero-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.hero-overlay {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: url('/public/assets/images/Product Listing Page/Rectangle 6.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.hero-title {
    font-family: 'Eczar', serif;
    font-size: 48px;
    font-weight: 700;
    color: #e37267;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
}

/* Category Navigation */
.category-nav {
    margin-top: 40px;
    border: 3px solid #e4b9a0;
    background: white;
    padding: 10px 0;
    overflow: hidden;
    position: relative;
}

.category-list-container {
    width: 100%;
    overflow: hidden;
}

.category-list-track {
    display: inline-flex;
    animation: scroll-infinite 40s linear infinite;
}

.category-nav:hover .category-list-track {
    animation-play-state: paused;
}

.category-item {
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    font-weight: 900;
    color: #000;
    padding: 0 30px;
    display: inline-block;
    flex-shrink: 0;
    white-space: nowrap;
    min-width: max-content;
}

/* Seamless infinite scroll animation */
@keyframes scroll-infinite {
    0% { 
        transform: translateX(0); 
    }
    100% { 
        /* Move exactly 50% (24 items out of 48) to create seamless loop */
        transform: translateX(-50%); 
    }
}

/* Main Container */
.shop-container {
    max-width: 1600px;
    margin: 0 auto;
    padding: 40px 20px;
}

/* Main Content Area */
.main-content {
    width: 100%;
}

/* Featured Section */
.featured-section {
    background: #ffeee5;
    border-radius: 20px;
    padding: 40px;
    margin-bottom: 100px;
}

.bestsellers-container {
    display: grid;
    grid-template-columns: 300px 1fr;
    gap: 40px;
}

/* Customization Card */
.customization-card {
    height: 650px;
    background: #f9eed9;
    border-radius: 10px;
    padding: 30px;
    box-shadow: 2px 4px 3px 2px rgba(99, 20, 20, 0.25);
    position: relative;
    top: 17%;
    z-index: 10;
    overflow: hidden; /* Avoid inner elements bleeding horizontally */
}

.custom-content {
    text-align: center;
}

.custom-image {
    width: 100%;
    height: 180px;
    object-fit: cover;
    border-radius: 8px;
    margin-bottom: 20px;
}

.custom-text h3 {
    font-family: 'Instrument Sans', sans-serif;
    text-align:left;
    font-size: 32px;
    font-weight: 500;
    font-style: italic;
    color: #e37267;
    line-height: 1.2;
    margin-bottom: 20px;
    text-shadow:
        -1px 0 #fff, 1px 0 #fff,
        0 -1px #fff, 0 1px #fff,
        -1px -1px #fff, 1px -1px #fff,
        -1px 1px #fff, 1px 1px #fff;
}

.journey-btn {
    background: #e37267;
    color: white;
    border: none;
    border-radius: 10px;
    padding: 18px 25px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    box-shadow: 2px 3px 2px 0px rgba(168, 98, 91, 0.9);
    transition: all 0.3s ease;
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    line-height: 1.2;
    text-align: left;
}

.journey-btn:hover {
    background: #d45d52;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(227, 114, 103, 0.4);
}

.arrow-icon {
    margin-left: 10px;
}

/* Featured Gift Boxes */
.featured-boxes {
    padding-top: 105px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 25px;
}

.gift-box-card {
    background-color: rgba(255, 255, 255, 0);
    border-radius: 5px;
    position: relative;
    cursor: pointer;
    transition: transform 0.3s ease;
    overflow: hidden; /* Prevent absolutely positioned children from overflowing */
}


.product-label {
    position: absolute;
    top: 15px;
    left: -5%;
    background: #f9eed9;
    padding: 5px 20px;
    font-family: 'Eczar', serif;
    font-size: 16px;
    font-weight: 500;
    color: #000;
    z-index: 2;
}


.discount-badge {
    position: absolute;
    background: url('/public/assets/images/Product Listing Page/Discount.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    top: 80px;
    left: 10px;
    width: 60px;
    height: 60px;
    z-index: 4;
    transform: scale(1.6);
}

.discount-badge span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-size: 14px;
    font-weight: bold;
}
.box-image {
  width: 100%;
  height: 0;               /* 高度由 padding 控制 */
  padding-top: 100%;       /* 100% of width = 正方形 */
  position: relative;
  border-radius: 12px;
  cursor: pointer;
  overflow: hidden;
  box-shadow: 0px 4px 4px 0px rgba(168, 98, 91, 0.9);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.box-image img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.box-image:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
}

.highlight-pulse {
    outline: 10px solid #e37267;
    outline-offset: 3px;
    animation: pulse-highlight 1.2s ease-in-out;
    border-radius: 12px;
}

@keyframes pulse-highlight {
    0% { box-shadow: 0 0 0 0 rgba(227, 114, 103, 0.6); }
    70% { box-shadow: 0 0 0 12px rgba(227, 114, 103, 0); }
    100% { box-shadow: 0 0 0 0 rgba(227, 114, 103, 0); }
}

.box-info {
    padding: 15px;
    
}

.box-info h4 {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 10px;
    color: #000;
}

.rating-price {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.rating {
    display: flex;
    align-items: center;
    gap: 4px;
}

.stars {
    color: #ffc107;
    font-size: 14px;
}

.rating span:last-child {
    font-size: 14px;
    font-weight: 600;
    color: #000;
}

.price-info {
    display: flex;
    align-items: center;
    gap: 8px;
}

.old-price {
    text-decoration: line-through;
    color: #d78d86;
    font-size: 14px;
}

.price {
    font-size: 14px;
    font-weight: normal;
    color: #000;
}

/* Filters Bar */
.filters-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 30px;
    padding: 20px 0;
    border-bottom: 1px solid #e4b9a0;
}

.filter-dropdown {
    padding: 8px 20px;
    border: 1.5px solid #e37267;
    border-radius: 8px;
    cursor: pointer;
}

.filter-label {
    font-size: 14px;
    font-weight: 600;
    color: #e37267;
}

.sort-section {
    display: flex;
    align-items: center;
    gap: 10px;
}

.sort-label {
    font-size: 14px;
    font-weight: 600;
    color: #e37267;
}

/* Price Range Section */
.price-range-section {
    display: flex;
    align-items: center;
    gap: 15px;
    flex: 1;
    max-width: 500px;
}

.price-label-left, .price-label-right {
    font-size: 14px;
    font-weight: 600;
    color: #000;
    min-width: 40px;
}

.price-label-left {
    text-align: right;
}

.price-slider-wrapper {
    flex: 1;
    position: relative;
}

.price-slider-container {
    position: relative;
    height: 20px;
    display: flex;
    align-items: center;
}

.price-values {
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
    padding: 0 10px;
}

.current-min, .current-max {
    font-size: 14px;
    font-weight: 600;
    color: #000;
}

.price-track {
    position: absolute;
    width: 100%;
    height: 1px;
    background: #000;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    z-index: 1;
}

.price-track-active {
    position: absolute;
    height: 100%;
    background: #000;
    top: 0;
    transition: left 0.2s ease, width 0.2s ease;
}

.price-slider {
    position: absolute;
    width: 100%;
    height: 20px;
    -webkit-appearance: none;
    appearance: none;
    background: transparent;
    outline: none;
    cursor: pointer;
    pointer-events: none;
}

.price-slider.min-slider {
    z-index: 4;
}

.price-slider.max-slider {
    z-index: 3;
}

.price-slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 20px;
    height: 20px;
    background: white;
    border: 2px solid #000;
    cursor: pointer;
    border-radius: 50%;
    pointer-events: auto;
    position: relative;
    z-index: 5;
}

.price-slider::-moz-range-thumb {
    width: 16px;
    height: 16px;
    background: white;
    border: 2px solid #000;
    cursor: pointer;
    border-radius: 50%;
    pointer-events: auto;
    position: relative;
    z-index: 5;
}

.price-slider::-webkit-slider-thumb:hover {
    transform: scale(1.1);
}

.price-slider::-moz-range-thumb:hover {
    transform: scale(1.1);
}

/* Stock Filters */
.stock-filters {
    display: flex;
    gap: 20px;
    align-items: center;
}

.checkbox-filter {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 14px;
    color: #000;
    font-weight: 600;
    user-select: none;
    position: relative;
    white-space: nowrap;
}

.checkbox-filter input[type="checkbox"] {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}

.checkbox-custom {
    position: relative;
    height: 16px;
    width: 16px;
    background-color: white;
    border: 2px solid #2c2c2c;
    border-radius: 4px;
    margin-right: 8px;
    transition: all 0.2s ease;
}

.checkbox-filter input:checked ~ .checkbox-custom {
    background-color: #2c2c2c;
    border-color: #2c2c2c;
}

.checkbox-custom:after {
    content: "";
    position: absolute;
    display: none;
}

.checkbox-filter input:checked ~ .checkbox-custom:after {
    display: block;
    left: 4px;
    top: 1px;
    width: 4px;
    height: 8px;
    border: solid #f5f5f5;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
}

/* Products Grid */
.products-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 25px;
    margin-bottom: 40px;
}

/* Product Card */
.product-card {
    background: white;
    border-radius: 5px;
    position: relative;
    cursor: pointer;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    overflow: hidden;
    box-shadow: 0px 4px 4px 0px rgba(168, 98, 91, 0.9);
}

.product-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
}

/* Product Badges */
.product-badges {
    position: absolute;
    top: 15px;
    left: 20px;
    z-index: 3;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.badge {
    background: #fffcea;
    border: 1.2px solid #e37267;
    border-radius: 20px;
    padding: 6px 16px;
    font-family: 'Instrument Sans', sans-serif;
    font-size: 14px;
    font-weight: 600;
    color: #e37267;
    white-space: nowrap;
}

.badge.hot-new {
    background: #ffeee5;
    border-color: #d45d52;
    color: #d45d52;
}

.badge.on-sale {
    background: #fffef9;
    border-color: #e37267;
    color: #e37267;
}

.badge.top-pick {
    background: #fffcea;
    border-color: #e37267;
    color: #e37267;
}

/* Discount Star */
.discount-star {
    position: absolute;
    top: 10px;
    left: 10px;
    width: 60px;
    height: 60px;
    z-index: 4;
}

.star-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.discount-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-size: 16px;
    font-weight: bold;
}

/* Product Image */
.product-image {
    width: 100%;
    height: 280px;
    overflow: hidden;
}

.product-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

/* Product Info */
.product-info {
    padding: 15px;
}

.product-name {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 10px;
    color: #000;
}

.product-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.star {
    color: #ffc107;
    font-size: 16px;
}

.rating-value {
    font-size: 14px;
    font-weight: 600;
    margin-left: 4px;
    color: #000;
}

.price-section {
    display: flex;
    align-items: center;
    gap: 8px;
}

.current-price {
    font-size: 14px;
    font-weight: normal;
    color: #000;
}

/* Loading */
.loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 400px;
}

.loader {
    width: 50px;
    height: 50px;
    border: 3px solid #f3f3f3;
    border-top: 3px solid #e37267;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

/* View More Section */
.view-more-section {
    text-align: center;
    padding: 20px;
    color: #e37267;
    font-size: 14px;
}

/* CTA Section */
.cta-section {
    background: #ffeee5;
    padding: 40px;
    text-align: center;
}

.cta-section h2 {
    font-size: 24px;
    font-weight: 600;
    color: rgba(168, 98, 91, 0.9);
    margin-bottom: 25px;
}

.cta-btn {
    background: #e37267;
    color: white;
    border: none;
    border-radius: 20px;
    padding: 10px 40px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    box-shadow: 2px 3px 2px 0px rgba(168, 98, 91, 0.9);
    transition: all 0.3s ease;
}

.cta-btn:hover {
    background: #d45d52;
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(227, 114, 103, 0.4);
}

/* Footer */
.main-footer {
    background: white;
    padding: 0;
}

.footer-top {
    background: #ffe1cf;
    padding: 8px;
    text-align: center;
}

.back-to-top {
    color: #000;
    font-size: 16px;
    font-weight: 500;
    text-decoration: none;
    cursor: pointer;
}

.back-to-top:hover {
    color: #e37267;
}

.footer-content {
    display: flex;
    justify-content: space-between;
    padding: 40px 80px;
    background: white;
}

.footer-columns {
    display: flex;
    gap: 80px;
}

.footer-column h4 {
    font-family: 'Eczar', serif;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 20px;
    color: #000;
}

.footer-column ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.footer-column li {
    font-size: 14px;
    font-weight: 500;
    color: #000;
    margin-bottom: 15px;
    cursor: pointer;
}

.footer-column li:hover {
    color: #e37267;
}

/* Footer Social */
.footer-social {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.footer-social h4 {
    font-size: 14px;
    font-weight: bold;
    color: #000;
    margin-bottom: 10px;
}

.social-links {
    display: flex;
    gap: 15px;
}

.social-links a {
    width: 26px;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.social-links img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

/* Newsletter */
.newsletter {
    margin-top: 20px;
}

.newsletter h4 {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 10px;
}

.newsletter p {
    font-size: 12px;
    color: #000;
    margin-bottom: 15px;
    max-width: 300px;
}

.sign-in-btn {
    background: #e37267;
    color: white;
    border: none;
    border-radius: 20px;
    padding: 10px 40px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    box-shadow: 2px 3px 2px 0px rgba(168, 98, 91, 0.9);
    transition: all 0.3s ease;
}

.sign-in-btn:hover {
    background: #d45d52;
    transform: translateY(-2px);
}

/* Footer Bottom */
.footer-bottom {
    padding: 20px;
    text-align: center;
    border-top: 1px solid #f0f0f0;
}

.footer-logo img {
    height: 40px;
    object-fit: contain;
}
.bestsellers-title{
    position: relative;
    left: -50%;
    top: -35%;
}
.bestsellers-title img{
    width: 340px;
    height: auto;
    max-width: 100%;
}

/* Responsive Design */
@media (max-width: 1200px) {
    .products-grid {
        grid-template-columns: repeat(3, 1fr);
    }
    
    .featured-boxes {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 992px) {
    .main-nav {
        gap: 20px;
    }
    
    .bestsellers-container {
        grid-template-columns: 1fr;
        gap: 30px;
    }
    
    .customization-card {
        max-width: 500px;
        margin: 0 auto;
    }
    
    .featured-boxes {
        grid-template-columns: repeat(3, 1fr);
    }
    
    .products-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 20px;
    }
    
    .footer-content {
        padding: 30px 40px;
    }
    
    .footer-columns {
        gap: 40px;
    }
}

@media (max-width: 768px) {
    .main-header {
        flex-wrap: wrap;
        height: auto;
        padding: 15px 20px;
    }
    
    .main-nav {
        order: 3;
        width: 100%;
        justify-content: center;
        margin-top: 10px;
        gap: 15px;
    }
    
    .nav-item {
        font-size: 12px;
    }
    
    .header-actions {
        gap: 10px;
    }
    
    .cart-btn, .login-btn {
        padding: 8px 20px;
        font-size: 12px;
    }
    
    .hero-section {
        height: 250px;
    }
    
    .hero-title {
        font-size: 36px;
    }
    
    .featured-section {
        padding: 20px;
    }
    
    .featured-boxes {
        grid-template-columns: 1fr;
    }
    
    .filters-bar {
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;
    }
    
    .price-range-section {
        width: 100%;
    }
    
    .stock-filters {
        flex-wrap: wrap;
    }
    
    .products-grid {
        grid-template-columns: 1fr;
        gap: 15px;
    }
    
    .footer-content {
        flex-direction: column;
        padding: 30px 20px;
    }
    
    .footer-columns {
        flex-wrap: wrap;
        gap: 30px;
        margin-bottom: 30px;
    }
    
    .footer-column {
        flex: 1 1 45%;
    }

}

@media (max-width: 480px) {
    .promo-banner {
        font-size: 12px;
    }
    
    .hero-title {
        font-size: 28px;
    }
    

    
    .custom-text h3 {
        font-size: 24px;
    }
    
    .journey-btn {
        font-size: 12px;
        padding: 14px 20px;
    }
    
    .product-card {
        box-shadow: 0px 2px 4px rgba(168, 98, 91, 0.5);
    }
    
    .footer-column {
        flex: 1 1 100%;
    }
}
</style>


